export const STAT_URL = 'https://datalens.yandex-team.ru/40drl3ffjr1ss-statistika-vod';
